import { AlertsWidget } from './widgets/Alerts';
import { CoverageOverTime } from './widgets/CoverageOverTime';
import { LatestAlertsWidget } from './widgets/LatestAlertsWidget';
import { MCPServersUsageWidget } from './widgets/MCPUsage';
import { PoliciesCoverageWidget } from './widgets/PoliciesCoverage';
import { TopAlertsWidget } from './widgets/TopAlerts';
import { DashboardErrorBoundary } from './DashboardErrorBoundary';
import { TopShadowAIUsers } from './widgets/TopShadowAIUsers';
import { MostActiveAITool } from './widgets/MostActiveAITool';
import { TopBrowserAITools } from './widgets/TopBrowserAITools';
import { TopAIInstalledTools } from './widgets/TopAIInstalledTools';

interface DashboardProps {
  isShadowAIEnabled?: boolean;
}

export const Dashboard = ({ isShadowAIEnabled = false }: DashboardProps) => {
  return (
    <DashboardErrorBoundary>
      <div className="mx-auto space-y-6">
        <div>
          <h2 className="text-lg font-semibold">General Usage</h2>
          <p className="text-sm text-muted-foreground mt-1">
            A high-level view of organization-wide alerts, coverage, and MCP
            usage.
          </p>
        </div>

        <div className="space-y-6 ml-4">
          <div className="grid grid-cols-12 gap-6">
            {/* Alerts Chart Widget */}
            <AlertsWidget />
            {/* Top Alerts Widget */}
            <TopAlertsWidget />
          </div>

          <div className="grid grid-cols-12 gap-6">
            {/* Latest Alerts Widget */}
            <LatestAlertsWidget />
            {/* Kirin Coverage Widget */}
            <CoverageOverTime />
            {/* Policies Coverage Widget */}
          </div>

          <div className="grid grid-cols-12 gap-6">
            <PoliciesCoverageWidget />
            <MCPServersUsageWidget />
          </div>
        </div>

        {isShadowAIEnabled && (
          <div className="space-y-3 border-t pt-6 ">
            <div>
              <h2 className="text-lg font-semibold">Shadow AI Insights</h2>
              <p className="text-sm text-muted-foreground mt-1">
                Monitor Shadow AI activity, usage patterns, and risk signals for
                your organization.
              </p>
            </div>
            <div className="space-y-6 ml-4">
              <div className="grid grid-cols-12 gap-6">
                <TopShadowAIUsers />
                <TopAIInstalledTools />
              </div>
              <div className="grid grid-cols-12 gap-6">
                <MostActiveAITool />
                <TopBrowserAITools />
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardErrorBoundary>
  );
};
